import { IAllocation, IAllocationData } from '../../types/Gameplan/IAllocation';
import { IProjectWorkstream } from '../../types/Gameplan/IProjectWorkstream';
import { ITicketWorkstream } from '../../types/Gameplan/ITicketWorkstream';
import { toMinutes } from '../../utils/utils';
import { Api } from './BaseApi'

const GameplanApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getTicketAllocation: build.query<IAllocation[], { ticketId: number }>({
            query: ({ ticketId }) => `Gameplan/Ticket/${ticketId}/Allocation`,
            providesTags: ["GameplanAllocation"],
        }),
        getTicketWorkstream: build.query<ITicketWorkstream, { ticketId: number }>({
            query: ({ ticketId }) => `Gameplan/Ticket/${ticketId}/Workstream`,
            providesTags: ["TicketWorkstream"],
        }),
        getProjectWorkstream: build.query<IProjectWorkstream, { projectId: number, workstreamId: number }>({
            query: ({ projectId, workstreamId }) => `Gameplan/Project/${projectId}/Workstream/${workstreamId}/`,
            providesTags: ["ProjectWorkstream"],
        }),
        updateAllocation: build.mutation<any, { ticketId: number, data: IAllocationData }>({
            query: (props) => ({
                url: `Gameplan/Ticket/${props.ticketId}/Allocation`,
                method: "POST",
                body: { ...props.data, Effort_Mins: toMinutes(props.data.Effort_Mins) }, // Convert time to minutes
            }),
            invalidatesTags: ["GameplanAllocation", "TicketWorkstream"],
        })
    })
})

export { GameplanApi };